// 9fbef606107a605d69c0edbcd8029e5d
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Row from '@tcp/core/src/components/common/atoms/Row';
import Col from '@tcp/core/src/components/common/atoms/Col';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Image from '@tcp/core/src/components/common/atoms/Image';
import { getLocator, getIconPath, isCanada } from '@tcp/core/src/utils';
import PriceCurrency from '@tcp/core/src/components/common/molecules/PriceCurrency';
import ErrorMessage from '@tcp/core/src/components/features/CnC/common/molecules/ErrorMessage';
import { getLabelFromCopyOrFromTranslation } from '@tcp/core/src/utils/labels/labelUtilty.js';
import ZipcodeForm from '../../ZipcodeForm';
import withStyles from '../../../../../../common/hoc/withStyles';
import styles from '../styles/EstimatedTax.style';
import orderLedgerLabels, {
  errorMessagessErrCodeGeneric,
  GLOBAL_ERRORS,
} from '../../../organism/OrderLedger/views/orderLedger.labels';

export const handleCarrottoggle = (dropdownOpen) => {
  return !dropdownOpen ? 'carrot-down-icon' : 'carrot-up-icon';
};

export const toggleFormField = (setDropDownOpen, dropdownOpen, isDisabled) =>
  setDropDownOpen(!dropdownOpen && !isDisabled);

const EstimatedTaxComponent = ({
  className,
  taxesTotal,
  zipCode,
  getEstimatedTaxAction,
  getIsFromEstimatedTaxForm,
  isTaxCalculated,
  zipCodeTaxError,
  spc,
  taxFromDefaultShippingAddress,
  plccShippingAddressUpdateActn,
  orderType,
  isAddToBagInProgress,
  isNonCacheDataLoaded,
  checkoutLabels,
}) => {
  const isDisabled = orderType === 'PURE_BOSS' || orderType === 'PURE_BOPIS';
  const [dropdownOpen, setDropDownOpen] = useState(false);
  const taxAddLabel = isCanada()
    ? checkoutLabels.bagPage?.lbl_estimated_tax_add_ca
    : checkoutLabels.bagPage?.lbl_estimated_tax_add;
  const zipCodeValue = zipCode || taxAddLabel;
  const onSubmit = (data) => {
    setDropDownOpen(false);
    const zipCodeData = data?.postalCode;
    getIsFromEstimatedTaxForm(true);
    taxFromDefaultShippingAddress(false);
    plccShippingAddressUpdateActn(false);
    getEstimatedTaxAction({ zipcode: zipCodeData });
  };

  useEffect(() => {
    if (zipCodeTaxError) {
      setDropDownOpen(true);
    }
  }, [zipCodeTaxError]);

  useEffect(() => {
    if (zipCode && !isTaxCalculated && !isAddToBagInProgress && isNonCacheDataLoaded === 'true') {
      getEstimatedTaxAction({ zipcode: zipCode });
    }
  }, [zipCode, isTaxCalculated, isAddToBagInProgress]);

  return (
    <>
      <Row
        className={`${dropdownOpen ? '' : 'tax-total'} rowMargin ${className}`}
        data-locator={getLocator('order_ledger_estimated_tax_label')}
      >
        {taxesTotal >= 0 ? (
          <>
            <Col colSize={{ large: 8, medium: 5, small: 4 }}>
              <BodyCopy
                bodySize="one"
                tag="span"
                color="primary"
                fontFamily="secondary"
                fontWeight="semibold"
                fontSize="fs16"
              >
                {`${checkoutLabels.bagPage?.lbl_orderledger_tax}:`}
                <BodyCopy
                  bodySize="one"
                  component="span"
                  color="primary"
                  fontFamily="secondary"
                  fontWeight="semibold"
                  fontSize="fs13"
                  onClick={() => toggleFormField(setDropDownOpen, dropdownOpen, isDisabled)}
                  className={`zipcode-value ${!isDisabled ? 'zipcode-anchor' : ''} `}
                >
                  {zipCodeValue}
                  {!isDisabled && (
                    <Image
                      alt="user"
                      className={`account-info ${handleCarrottoggle(dropdownOpen)}`}
                      src={getIconPath('down_arrow_icon')}
                      height="6px"
                    />
                  )}
                </BodyCopy>
              </BodyCopy>
            </Col>
            <Col colSize={{ large: 4, medium: 3, small: 2 }}>
              <BodyCopy
                bodySize="one"
                color="primary"
                fontFamily="secondary"
                fontWeight="semibold"
                fontSize="fs16"
                textAlign="right"
              >
                <PriceCurrency price={taxesTotal} />
              </BodyCopy>
            </Col>
          </>
        ) : null}
      </Row>
      {dropdownOpen ? (
        <>
          <ZipcodeForm onSubmit={onSubmit} checkoutLabels={checkoutLabels} />
          <ErrorMessage
            error={
              zipCodeTaxError &&
              getLabelFromCopyOrFromTranslation(
                `${GLOBAL_ERRORS}.${errorMessagessErrCodeGeneric}`,
                orderLedgerLabels
              )
            }
            spc={spc}
            className="zip-error"
            comp="zip-comp"
          />
        </>
      ) : null}
    </>
  );
};

EstimatedTaxComponent.propTypes = {
  className: PropTypes.string.isRequired,
  taxesTotal: PropTypes.number.isRequired,
  zipCode: PropTypes.string.isRequired,
};

export default withStyles(EstimatedTaxComponent, styles);
export { EstimatedTaxComponent as EstimatedTaxComponentVanilla };
